import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/vecura-logo.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4f1be2ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vecura-page" }
const _hoisted_2 = {
  class: "section vecura-hero",
  "aria-labelledby": "vecura-title"
}
const _hoisted_3 = { class: "vecura-hero__content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "vecura-hero__logo",
  src: _imports_0,
  alt: "Vecura"
}, null, -1))
const _hoisted_5 = { id: "vecura-title" }
const _hoisted_6 = { class: "vecura-hero__contact" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "vecura-hero__role" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Meine Rolle", -1))
const _hoisted_10 = { class: "section vecura-pitch" }
const _hoisted_11 = { class: "vecura-pitch__copy" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Plattform", -1))
const _hoisted_13 = { class: "vecura-pitch__proof" }
const _hoisted_14 = { class: "section vecura-capabilities" }
const _hoisted_15 = { class: "vecura-capabilities__grid" }
const _hoisted_16 = { class: "section vecura-case" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vecura-case__label" }, "Case Study", -1))
const _hoisted_18 = { class: "vecura-case__body" }
const _hoisted_19 = { class: "section vecura-contact" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Kontakt"),
  /*#__PURE__*/_createElementVNode("h2", null, "Wenn Fachwissen schneller nutzbar werden soll.")
], -1))
const _hoisted_21 = { class: "vecura-contact__actions" }
const _hoisted_22 = ["href"]
const _hoisted_23 = {
  class: "vecura-contact__back",
  href: "/"
}

import ArrowLeftIcon from "@/components/icons/ArrowLeftIcon.vue";
import ContactChannelIcon from "@/components/icons/ContactChannelIcon.vue";
import ExternalLinkIcon from "@/components/icons/ExternalLinkIcon.vue";
import SectionHeading from "@/components/SectionHeading.vue";
import { vecuraPage } from "@/data/profile";
import { createMailtoHref, vecuraEmail } from "@/utils/contact";

const vecuraWebsiteUrl = "https://vecura.io";
const vecuraLinkedinUrl = "https://www.linkedin.com/company/vecura-gmbh";

export default /*#__PURE__*/_defineComponent({
  __name: 'VecuraPage',
  setup(__props) {

const vecuraEmailHref = createMailtoHref(vecuraEmail);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", null, _toDisplayString(_unref(vecuraPage).eyebrow), 1),
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(vecuraPage).headline), 1),
        _createElementVNode("span", null, _toDisplayString(_unref(vecuraPage).intro), 1),
        _createElementVNode("p", _hoisted_6, [
          _createTextVNode(" Kontakt über "),
          _createElementVNode("a", {
            href: vecuraWebsiteUrl,
            target: "_blank",
            rel: "noopener noreferrer"
          }, " vecura.io "),
          _createTextVNode(", "),
          _createElementVNode("a", {
            href: vecuraLinkedinUrl,
            target: "_blank",
            rel: "noopener noreferrer"
          }, " LinkedIn "),
          _createTextVNode(" oder "),
          _createElementVNode("a", { href: _unref(vecuraEmailHref) }, "E-Mail", 8, _hoisted_7),
          _createTextVNode(". ")
        ])
      ]),
      _createElementVNode("aside", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("p", null, _toDisplayString(_unref(vecuraPage).role), 1),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vecuraPage).rolePoints, (point) => {
            return (_openBlock(), _createElementBlock("li", { key: point }, _toDisplayString(point), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("h2", null, _toDisplayString(_unref(vecuraPage).pitch), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vecuraPage).proofPoints, (point) => {
          return (_openBlock(), _createElementBlock("article", {
            key: point.value
          }, [
            _createElementVNode("strong", null, _toDisplayString(point.value), 1),
            _createElementVNode("span", null, _toDisplayString(point.label), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_14, [
      _createVNode(SectionHeading, {
        eyebrow: "Was Vecura leistet",
        title: "Wert entsteht nicht im Modell allein, sondern im Zusammenspiel aus Daten, Suche und Kontext.",
        description: "Vecura verbindet Plattformbausteine mit individueller Konfiguration, damit Organisationen schneller zu belastbaren Wissensanwendungen kommen."
      }),
      _createElementVNode("div", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vecuraPage).capabilities, (capability) => {
          return (_openBlock(), _createElementBlock("article", {
            key: capability.title
          }, [
            _createElementVNode("h3", null, _toDisplayString(capability.title), 1),
            _createElementVNode("p", null, _toDisplayString(capability.description), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("h2", null, _toDisplayString(_unref(vecuraPage).caseStudy.title), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(vecuraPage).caseStudy.summary), 1),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vecuraPage).caseStudy.details, (detail) => {
            return (_openBlock(), _createElementBlock("li", { key: detail }, _toDisplayString(detail), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("a", {
          class: "button-link button-link--yellow",
          href: vecuraWebsiteUrl,
          target: "_blank",
          rel: "noopener noreferrer"
        }, [
          _createVNode(ContactChannelIcon, {
            class: "vecura-contact__brand-icon",
            type: "vecura"
          }),
          _createTextVNode(" Website öffnen "),
          _createVNode(ExternalLinkIcon, { class: "vecura-contact__action-icon" })
        ]),
        _createElementVNode("a", {
          class: "button-link button-link--secondary",
          href: vecuraLinkedinUrl,
          target: "_blank",
          rel: "noopener noreferrer"
        }, [
          _createVNode(ContactChannelIcon, {
            class: "vecura-contact__brand-icon",
            type: "linkedin"
          }),
          _createTextVNode(" LinkedIn "),
          _createVNode(ExternalLinkIcon, { class: "vecura-contact__action-icon" })
        ]),
        _createElementVNode("a", {
          class: "button-link button-link--secondary",
          href: _unref(vecuraEmailHref)
        }, [
          _createVNode(ContactChannelIcon, {
            class: "vecura-contact__brand-icon",
            type: "mail"
          }),
          _createTextVNode(" E-Mail "),
          _createVNode(ExternalLinkIcon, { class: "vecura-contact__action-icon" })
        ], 8, _hoisted_22),
        _createElementVNode("a", _hoisted_23, [
          _createVNode(ArrowLeftIcon, { class: "vecura-contact__back-icon" }),
          _createTextVNode(" Zurück zum Profil ")
        ])
      ])
    ])
  ]))
}
}

})